// extracted by mini-css-extract-plugin
export default {"cart":"Cart_cart__gRJzC","item_name":"Cart_item_name__JDHqG","btn_buyer":"Cart_btn_buyer__kgOD0"};